import React, { useState } from 'react'

import app from '../assets/images/app.png'
import play from '../assets/images/play.png'
import phone from '../assets/images/phone/half-2.png'

import { FiSmartphone, FiX, FiDownload, FiShield, FiMail } from 'react-icons/fi'

export default function Download() {
  const [showModal, setShowModal] = useState(false)
  const [storeType, setStoreType] = useState<'apple' | 'google'>('google')

  const handleStoreClick = (e: React.MouseEvent, type: 'apple' | 'google') => {
    e.preventDefault()
    setStoreType(type)
    setShowModal(true)
  }

  return (
    <>
        <div className="container relative">
            <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
                <div className="lg:col-span-5 md:col-span-6">
                    <div className="pt-6 px-6 rounded-2xl bg-red-500/5 dark:bg-red-500/10 shadow shadow-red-500/20">
                        <img src={phone} alt=""/>
                    </div>
                </div>

                <div className="lg:col-span-7 md:col-span-6">
                    <div className="lg:ms-10">                        <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">HATİM TAKİP Her An Yanında!</h6>
                        <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Yolda, evde, okulda... </h4>
                        <p className="text-slate-400 max-w-xl mb-0">Nerede olursan ol, Kur’an ve Risale okumalarını takip etmek artık cebinde! Hemen indir, okumaya birlikte devam edelim.</p>                        <div className="my-6">
                            <button onClick={(e) => handleStoreClick(e, 'apple')} className="cursor-pointer">
                                <img src={app} className="h-12 inline-block m-1" alt="App Store"/>
                            </button>
                            <button onClick={(e) => handleStoreClick(e, 'google')} className="cursor-pointer">
                                <img src={play} className="h-12 inline-block m-1" alt="Google Play"/>
                            </button>
                        </div>

                        {/* Bilgilendirme satırı kaldırıldı */}
                    </div>
                </div>
            </div>
        </div>

        {/* Popup Modal */}
        {showModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white dark:bg-slate-900 p-6 rounded-lg shadow-lg max-w-md w-full mx-4 relative">
              {/* Close Button */}
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                <FiX className="size-6" />
              </button>
              
              {/* Modal Content */}
              <div className="text-center">
                <div className="mb-4">
                  <FiSmartphone className="mx-auto text-red-500 size-16" />
                </div>
                
                <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
                  Hatim Takip Uygulaması
                </h3>
                
                <div className="space-y-4 text-left">
                  <div className="flex items-start space-x-3">
                    <FiShield className="text-green-500 size-5 mt-1 flex-shrink-0" />
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {storeType === 'apple' 
                        ? "Uygulamamız şuanda App Store doğrulama ve test aşamasında olduğu için dilerseniz direkt APK olarak da indirebilirsiniz."
                        : "Uygulamamız şuanda Google Play doğrulama ve test aşamasında olduğu için dilerseniz direkt APK olarak da indirebilirsiniz."
                      }
                    </p>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <FiShield className="text-green-500 size-5 mt-1 flex-shrink-0" />
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {storeType === 'apple'
                        ? "Uygulamamız Apple tarafından onaylanmıştır ve hiçbir güvenlik sorunu yoktur."
                        : "Uygulamamız Google Play Protect tarafından onaylanmıştır ve hiçbir güvenlik sorunu yoktur."
                      }
                    </p>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <FiMail className="text-blue-500 size-5 mt-1 flex-shrink-0" />
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Uygulama ile ilgili sorun ve görüşlerinizi paylaşmak için{' '}
                      <a href="mailto:gudersamet@gmail.com" className="text-red-500 hover:text-red-600 font-medium">
                        gudersamet@gmail.com
                      </a>{' '}
                      adresine mail gönderebilirsiniz.
                    </p>
                  </div>
                </div>
                
                <div className="mt-6 space-y-3">
                  {storeType === 'google' ? (
                    <a
                      href="https://expo.dev/artifacts/eas/2GRj8TuCDbUNLWsuRehcP6.apk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full inline-flex items-center justify-center px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition duration-300"
                    >
                      <FiDownload className="mr-2" />
                      APK İndir
                    </a>
                  ) : (
                    <div className="w-full text-center p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                      <p className="text-sm text-blue-700 dark:text-blue-300">
                        iOS sürümü App Store onayından sonra indirilebilir olacaktır.
                      </p>
                    </div>
                  )}
                  
                  <button
                    onClick={() => setShowModal(false)}
                    className="w-full px-4 py-2 bg-gray-300 hover:bg-gray-400 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg transition duration-300"
                  >
                    Kapat
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
  )
}
